(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 171);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var transformNodeText = function transformNodeText(text) {
  return text.toLowerCase().trim().replace(/[\s\-\.]/g, '_');
};

var getCompanyFromNode = function getCompanyFromNode(node) {
  var companyNode = node.querySelector(".project-overlay__company");

  return transformNodeText(companyNode.innerHTML);
};

var convertLanguage = {
  'ca_en': 'en_CA',
  'ko': 'ko_KR',
  'fi': 'fi_FI',
  'zh': 'zh_CH',
  'au': 'en_AU',
  'gb': 'en_GB',
  'la_es': 'es_LATAM',
  'ca_fr': 'fr_CA'
};

var getVideoPayload = function getVideoPayload(node, currentPage) {
  var lang = convertLanguage[currentPage];
  var current_page = getCurrentPage(currentPage);
  var feature = node.getAttribute('data-feature');

  return lang ? { region: lang, feature: feature } : { current_page: current_page, feature: feature };
};

var getDownloadPayload = function getDownloadPayload(node, currentPage) {
  var lang = convertLanguage[currentPage];
  var current_page = getCurrentPage(currentPage);
  var platform = node.getAttribute('data-platform');

  return lang ? { region: lang, platform: platform } : { current_page: current_page, platform: platform };
};

var getCurrentPage = function getCurrentPage(pagename) {
  var regional = isRegionalPage(pagename);

  if (pagename.match(/\./)) return pagename.split('.')[1];

  return regional || pagename;
};

var isRegionalPage = function isRegionalPage(currentPage) {
  return convertLanguage[currentPage];
};

var getHref = function getHref(node) {
  return transformNodeText(node.getAttribute('href'));
};

var getRegionalHeaderLinkName = function getRegionalHeaderLinkName(node) {
  var linkName = node.getAttribute('data-link-name');
  if (linkName) return linkName;

  var splitHref = node.href.split('/');
  var clickedLink = splitHref[splitHref.length - 1].replace('-', '_');

  return clickedLink === '' ? "en_US" : convertLanguage[clickedLink];
};

var featureExploreEventName = function featureExploreEventName(pagename) {
  var regional = isRegionalPage(pagename);

  return regional ? 'splash.regional.feature_explore.click' : 'splash.feature_explore.click';
};

var downloadEventName = function downloadEventName(pagename) {
  var regional = isRegionalPage(pagename);

  return regional ? 'splash.regional.download.click' : 'splash.product.download.click';
};

module.exports = {
  transformNodeText: transformNodeText,
  getCompanyFromNode: getCompanyFromNode,
  getHref: getHref,
  getCurrentPage: getCurrentPage,
  getRegionalHeaderLinkName: getRegionalHeaderLinkName,
  convertLanguage: convertLanguage,
  getVideoPayload: getVideoPayload,
  getDownloadPayload: getDownloadPayload,
  featureExploreEventName: featureExploreEventName,
  downloadEventName: downloadEventName
};

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookie = getCookie;
exports.jsonpSuccess = jsonpSuccess;
exports.detectUserCountry = detectUserCountry;
exports.changePhoneNumbers = changePhoneNumbers;
exports.openNewWindow = openNewWindow;
exports.getParameterByName = getParameterByName;
exports.insertUtmInForms = insertUtmInForms;
exports.insertUtmInFormsFields = insertUtmInFormsFields;
exports.convertMonthFormat = convertMonthFormat;
exports.convertTimeFormat = convertTimeFormat;
exports.convertTimezone = convertTimezone;
exports.embbedSvgImages = embbedSvgImages;
exports._ = _;
exports.showPopUp = showPopUp;
exports.getClosest = getClosest;
/*
 * Syntatic sugar
 */
var qs = exports.qs = function qs(x) {
  return document.querySelector(x);
};

var qsa = exports.qsa = function qsa(x) {
  return document.querySelectorAll(x);
};

/*
 * Custom get a cookie value
 */
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/*
 * callback for detectUserCountry ajax call
 */
function jsonpSuccess(response) {

  document.cookie = 'userCountry=' + response.country;
  userCountry = response.country;

  changePhoneNumbers(userCountry);
}

/*
 * Detect user country and change phones
 */

function detectUserCountry() {

  //Check user location
  var userCountry = getCookie('userCountry');
  if (userCountry === '') {

    var scr = document.createElement('script');
    scr.src = '//ipinfo.io?callback=jsonpSuccess';
    document.body.appendChild(scr);
  } else {
    changePhoneNumbers(userCountry);
  }
}

function changePhoneNumbers(userCountry) {

  switch (userCountry) {

    case 'AU':
      qs('.conditional-phone-number-small').innerHTML('1800 316 406');
      qs('.conditional-phone-number-big').innerHTML('1800 316 406');
      qs('.conditional-phone-number-link').setAttribute('href', 'tel:+611800316406');
      break;

    case 'GB':
      qs('.conditional-phone-number-small').innerHTML('020 3695 0292');
      qs('.conditional-phone-number-big').innerHTML('+44 (0)20 3695 0292');
      qs('.conditional-phone-number-link').setAttribute('href', 'tel:+4402036950292');
      break;

    case 'US':
      qs('.conditional-phone-number-small').innerHTML('800-646-0796');
      qs('.conditional-phone-number-big').innerHTML('+1 (800) 646-0796');
      qs('.conditional-phone-number-link').setAttribute('href', 'tel:+18006460796');
      qs('.int-locations').before(qs('.us-locations'));
      break;

  }
}

function openNewWindow() {
  qs("a.btn").setAttribute("target", "_blank");
  qs("a.button").setAttribute("target", "_blank");
}

/*
 * Get query values on URL
 */
function getParameterByName(name, url) {

  if (!url) {
    url = window.location.href;
  }

  name = name.replace(/[\[\]]/g, "\\$&");

  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);

  if (!results) {
    return null;
  }

  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/*
 * Automatically insert UTM variables on forms
 */
function insertUtmInForms() {

  var utmList = ['utm_source', 'utm_medium', 'utm_campaign'],
      check = '';

  for (var i = 0; i < utmList.length; i++) {

    check = getParameterByName(utmList[i]);
    if (check !== null && check !== '') {
      insertUtmInFormsFields(utmList[i], check);
    }
  }
}

function insertUtmInFormsFields(name, value) {
  if (qs('form')) {
    qs('form').prepend('<input type="hidden" name="' + name + '" value="' + value + '" />');
  }
}

insertUtmInForms();

/*
 * Convert Month Format
 */
function convertMonthFormat(date, format) {

  months = {
    'JAN': '01',
    'FEB': '02',
    'MAR': '03',
    'APR': '04',
    'MAY': '05',
    'JUN': '06',
    'JUL': '07',
    'AUG': '08',
    'SEP': '09',
    'OCT': '10',
    'NOV': '11',
    'DEC': '12'
  };
  year = new Date().getFullYear();

  if (format == 'google') {

    day = parseInt(date.replace(/\D/g, ''));
    if (day < 10) {
      day = '0' + day;
    }

    date = date.toUpperCase();

    Object.keys(months).forEach(function (item, index) {
      if (date.search(item) >= 0) {
        month = months[item];
        return false;
      }
    });

    return '' + year + '' + month + '' + day;
  }
}

function convertTimeFormat(date) {

  hours = date.split('-');
  if (hours[0].search("am") >= 0) {

    start = hours[0].trim().replace('am', '');

    if (start.search(':') >= 0) {

      start.replace(':', '');
      if (start.length < 4) {
        start = '0' + start;
      }

      start = '' + start + '00';
    } else {

      if (start.length < 2) {
        start = '0' + start;
      }

      start = '' + start + '0000';
    }
  } else {

    start = hours[0].trim().replace('pm', '');

    if (start.search(':') >= 0) {

      start.replace(':', '');
    }

    start = parseInt(start) + 1200;
    start = '' + start + '00';
  }

  if (hours[1].search("am") >= 0) {

    end = hours[1].trim().replace('am', '');

    if (end.search(':') >= 0) {

      end.replace(':', '');

      if (end.length < 4) {
        end = '0' + end;
      }
    } else {
      if (end.length < 2) {
        end = '0' + end + '00';
      }

      end = '' + end + '0000';
    }
  } else {

    end = hours[1].trim().replace('pm', '');

    if (end.search(':') >= 0) {

      end.replace(':', '');
    }

    end = parseInt(end) * 100 + 1200;
    end = '' + end + '00';
  }

  return { 0: start, 1: end };
}

function convertTimezone(timezone, startDate) {

  switch (timezone) {
    case "Atlantic":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "ADT";
      } else {
        timeZone = "AST";
      }
      break;

    case "Alaska":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "AKDT";
      } else {
        timeZone = "AKST";
      }
      break;

    case "Central":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "CDT";
      } else {
        timeZone = "CST";
      }
      break;

    case "Eastern":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "EDT";
      } else {
        timeZone = "EST";
      }
      break;

    case "Hawaii":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "HADT";
      } else {
        timeZone = "HAST";
      }
      break;

    case "Mountain":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "MDT";
      } else {
        timeZone = "MST";
      }
      break;

    case "Newfoundland":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "NDT";
      } else {
        timeZone = "NST";
      }
      break;

    case "Pacific":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "PDT";
      } else {
        timeZone = "PST";
      }
      break;

    case "Pierre & Miquelon":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "PMDT";
      } else {
        timeZone = "PMST";
      }
      break;

    case "Western Greenland":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "WGST";
      } else {
        timeZone = "WGT";
      }
      break;

    default:
      timeZone = "";

  }

  return timeZone;
}

/*
 * Replace all SVG images with inline SVG
 */
function embbedSvgImages() {
  var parser = new DOMParser();

  qsa('img.svg').forEach(function (item, index) {
    //console.log('item',item);
    var img = item;
    var imgID = img.id;
    var imgClass = img.classList.item(0);
    var imgURL = img.getAttribute('src');

    var httpRequest = new XMLHttpRequest();
    httpRequest.onreadystatechange = function () {
      if (httpRequest.readyState === XMLHttpRequest.DONE && httpRequest.status === 200) {
        var data = httpRequest.responseText;
        var doc = parser.parseFromString(data, "image/svg+xml");

        var svg = doc.querySelector('svg');

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== 'undefined') {
          svg.setAttribute('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== 'undefined') {
          svg.classList.add(imgClass);
          svg.classList.add('replaced-svg');
        }

        svg.removeAttribute('xmlns:a');

        img.parentNode.appendChild(svg);
        img.remove();
      }
    };
    httpRequest.open('GET', imgURL);
    httpRequest.send();
  });
}

/*
 * pure JS fade
 */

function _(el) {
  if (!(this instanceof _)) {
    return new _(el);
  }
  this.el = document.getElementById(el);
}

_.prototype.fade = function fade(type, ms) {
  var isIn = type === 'in',
      opacity = isIn ? 0 : 1,
      interval = 50,
      duration = ms,
      gap = interval / duration,
      self = this;

  if (isIn) {
    self.el.style.display = 'inline';
    self.el.style.opacity = opacity;
  }

  function func() {
    opacity = isIn ? opacity + gap : opacity - gap;
    self.el.style.opacity = opacity;

    if (opacity <= 0) self.el.style.display = 'none';
    if (opacity <= 0 || opacity >= 1) window.clearInterval(fading);
  }

  var fading = window.setInterval(func, interval);
};

/*
 * Pop Up
 */
function showPopUp(content, footerContent) {

  if (content !== '') {
    qs('#popup .box-content').innerHTML(content);
  }

  if (footerContent !== '') {
    qs('#popup .box-footer').innerHTML(footerContent);
  } else {
    qs('#popup .box-footer').remove();
  }

  qs('#popup').style.display = '';
  _('#popup').fade('out', 0);
  _('#popup').fade('in', 500);

  qs('#popup .close-button').addEventListener('click', function (e) {

    e.preventDefault();

    _('#popup').fade('out', 0);
  });
}

/**
 * Get the closest matching element up the DOM tree.
 * @private
 * @param  {Element} elem     Starting element
 * @param  {String}  selector Selector to match against
 * @return {Boolean|Element}  Returns null if not match found
 */
function getClosest(elem, selector) {

  // Element.matches() polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i = matches.length;
      while (--i >= 0 && matches.item(i) !== this) {}
      return i > -1;
    };
  }

  // Get closest match
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.matches(selector)) return elem;
  }

  return null;
}

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function init() {
  var langMenu = document.querySelector('.language');
  var langToggle = document.querySelector('.toggle');
  var navigation = document.querySelector('.regional-navigation');
  var menuToggle = document.querySelector('.menu-toggle');

  langToggle.addEventListener('click', function (e) {
    langMenu.classList.toggle('open');
  }, false);

  menuToggle.addEventListener('click', function (e) {
    navigation.classList.toggle('open');
  }, false);

  window.addEventListener('scroll', function (e) {
    if (window.scrollY > 0) {
      navigation.classList.add('shadow');
    } else {
      navigation.classList.remove('shadow');
    }
  }, false);
}

document.addEventListener('DOMContentLoaded', init);

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 116:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 2017 Julian Garnier
 Released under the MIT license
*/
var $jscomp$this=this;
(function(v,p){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (p),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"===typeof module&&module.exports?module.exports=p():v.anime=p()})(this,function(){function v(a){if(!g.col(a))try{return document.querySelectorAll(a)}catch(b){}}function p(a){return a.reduce(function(a,d){return a.concat(g.arr(d)?p(d):d)},[])}function w(a){if(g.arr(a))return a;g.str(a)&&(a=v(a)||a);return a instanceof NodeList||a instanceof HTMLCollection?[].slice.call(a):[a]}function F(a,b){return a.some(function(a){return a===b})}
function A(a){var b={},d;for(d in a)b[d]=a[d];return b}function G(a,b){var d=A(a),c;for(c in a)d[c]=b.hasOwnProperty(c)?b[c]:a[c];return d}function B(a,b){var d=A(a),c;for(c in b)d[c]=g.und(a[c])?b[c]:a[c];return d}function S(a){a=a.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i,function(a,b,d,h){return b+b+d+d+h+h});var b=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(a);a=parseInt(b[1],16);var d=parseInt(b[2],16),b=parseInt(b[3],16);return"rgb("+a+","+d+","+b+")"}function T(a){function b(a,b,c){0>
c&&(c+=1);1<c&&--c;return c<1/6?a+6*(b-a)*c:.5>c?b:c<2/3?a+(b-a)*(2/3-c)*6:a}var d=/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(a);a=parseInt(d[1])/360;var c=parseInt(d[2])/100,d=parseInt(d[3])/100;if(0==c)c=d=a=d;else{var e=.5>d?d*(1+c):d+c-d*c,l=2*d-e,c=b(l,e,a+1/3),d=b(l,e,a);a=b(l,e,a-1/3)}return"rgb("+255*c+","+255*d+","+255*a+")"}function x(a){if(a=/([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|pc|vw|vh|deg|rad|turn)?/.exec(a))return a[2]}function U(a){if(-1<a.indexOf("translate"))return"px";
if(-1<a.indexOf("rotate")||-1<a.indexOf("skew"))return"deg"}function H(a,b){return g.fnc(a)?a(b.target,b.id,b.total):a}function C(a,b){if(b in a.style)return getComputedStyle(a).getPropertyValue(b.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase())||"0"}function I(a,b){if(g.dom(a)&&F(V,b))return"transform";if(g.dom(a)&&(a.getAttribute(b)||g.svg(a)&&a[b]))return"attribute";if(g.dom(a)&&"transform"!==b&&C(a,b))return"css";if(null!=a[b])return"object"}function W(a,b){var d=U(b),d=-1<b.indexOf("scale")?
1:0+d;a=a.style.transform;if(!a)return d;for(var c=[],e=[],l=[],h=/(\w+)\((.+?)\)/g;c=h.exec(a);)e.push(c[1]),l.push(c[2]);a=l.filter(function(a,c){return e[c]===b});return a.length?a[0]:d}function J(a,b){switch(I(a,b)){case "transform":return W(a,b);case "css":return C(a,b);case "attribute":return a.getAttribute(b)}return a[b]||0}function K(a,b){var d=/^(\*=|\+=|-=)/.exec(a);if(!d)return a;b=parseFloat(b);a=parseFloat(a.replace(d[0],""));switch(d[0][0]){case "+":return b+a;case "-":return b-a;case "*":return b*
a}}function D(a){return g.obj(a)&&a.hasOwnProperty("totalLength")}function X(a,b){function d(c){c=void 0===c?0:c;return a.el.getPointAtLength(1<=b+c?b+c:0)}var c=d(),e=d(-1),l=d(1);switch(a.property){case "x":return c.x;case "y":return c.y;case "angle":return 180*Math.atan2(l.y-e.y,l.x-e.x)/Math.PI}}function L(a,b){var d=/-?\d*\.?\d+/g;a=D(a)?a.totalLength:a;if(g.col(a))b=g.rgb(a)?a:g.hex(a)?S(a):g.hsl(a)?T(a):void 0;else{var c=x(a);a=c?a.substr(0,a.length-c.length):a;b=b?a+b:a}b+="";return{original:b,
numbers:b.match(d)?b.match(d).map(Number):[0],strings:b.split(d)}}function Y(a,b){return b.reduce(function(b,c,e){return b+a[e-1]+c})}function M(a){return(a?p(g.arr(a)?a.map(w):w(a)):[]).filter(function(a,d,c){return c.indexOf(a)===d})}function Z(a){var b=M(a);return b.map(function(a,c){return{target:a,id:c,total:b.length}})}function aa(a,b){var d=A(b);if(g.arr(a)){var c=a.length;2!==c||g.obj(a[0])?g.fnc(b.duration)||(d.duration=b.duration/c):a={value:a}}return w(a).map(function(a,c){c=c?0:b.delay;
a=g.obj(a)&&!D(a)?a:{value:a};g.und(a.delay)&&(a.delay=c);return a}).map(function(a){return B(a,d)})}function ba(a,b){var d={},c;for(c in a){var e=H(a[c],b);g.arr(e)&&(e=e.map(function(a){return H(a,b)}),1===e.length&&(e=e[0]));d[c]=e}d.duration=parseFloat(d.duration);d.delay=parseFloat(d.delay);return d}function ca(a){return g.arr(a)?y.apply(this,a):N[a]}function da(a,b){var d;return a.tweens.map(function(c){c=ba(c,b);var e=c.value,l=J(b.target,a.name),h=d?d.to.original:l,h=g.arr(e)?e[0]:h,m=K(g.arr(e)?
e[1]:e,h),l=x(m)||x(h)||x(l);c.isPath=D(e);c.from=L(h,l);c.to=L(m,l);c.start=d?d.end:a.offset;c.end=c.start+c.delay+c.duration;c.easing=ca(c.easing);c.elasticity=(1E3-Math.min(Math.max(c.elasticity,1),999))/1E3;g.col(c.from.original)&&(c.round=1);return d=c})}function ea(a,b){return p(a.map(function(a){return b.map(function(b){var c=I(a.target,b.name);if(c){var d=da(b,a);b={type:c,property:b.name,animatable:a,tweens:d,duration:d[d.length-1].end,delay:d[0].delay}}else b=void 0;return b})})).filter(function(a){return!g.und(a)})}
function O(a,b,d){var c="delay"===a?Math.min:Math.max;return b.length?c.apply(Math,b.map(function(b){return b[a]})):d[a]}function fa(a){var b=G(ga,a),d=G(ha,a),c=Z(a.targets),e=[],g=B(b,d),h;for(h in a)g.hasOwnProperty(h)||"targets"===h||e.push({name:h,offset:g.offset,tweens:aa(a[h],d)});a=ea(c,e);return B(b,{children:[],animatables:c,animations:a,duration:O("duration",a,d),delay:O("delay",a,d)})}function n(a){function b(){return window.Promise&&new Promise(function(a){return Q=a})}function d(a){return f.reversed?
f.duration-a:a}function c(a){for(var b=0,c={},d=f.animations,e={};b<d.length;){var g=d[b],h=g.animatable,m=g.tweens;e.tween=m.filter(function(b){return a<b.end})[0]||m[m.length-1];e.isPath$1=e.tween.isPath;e.round=e.tween.round;e.eased=e.tween.easing(Math.min(Math.max(a-e.tween.start-e.tween.delay,0),e.tween.duration)/e.tween.duration,e.tween.elasticity);m=Y(e.tween.to.numbers.map(function(a){return function(b,c){c=a.isPath$1?0:a.tween.from.numbers[c];b=c+a.eased*(b-c);a.isPath$1&&(b=X(a.tween.value,
b));a.round&&(b=Math.round(b*a.round)/a.round);return b}}(e)),e.tween.to.strings);ia[g.type](h.target,g.property,m,c,h.id);g.currentValue=m;b++;e={isPath$1:e.isPath$1,tween:e.tween,eased:e.eased,round:e.round}}if(c)for(var k in c)E||(E=C(document.body,"transform")?"transform":"-webkit-transform"),f.animatables[k].target.style[E]=c[k].join(" ");f.currentTime=a;f.progress=a/f.duration*100}function e(a){if(f[a])f[a](f)}function g(){f.remaining&&!0!==f.remaining&&f.remaining--}function h(a){var h=f.duration,
l=f.offset,n=f.delay,P=f.currentTime,q=f.reversed,r=d(a),r=Math.min(Math.max(r,0),h);if(f.children){var p=f.children;if(r>=f.currentTime)for(var u=0;u<p.length;u++)p[u].seek(r);else for(u=p.length;u--;)p[u].seek(r)}r>l&&r<h?(c(r),!f.began&&r>=n&&(f.began=!0,e("begin")),e("run")):(r<=l&&0!==P&&(c(0),q&&g()),r>=h&&P!==h&&(c(h),q||g()));a>=h&&(f.remaining?(t=m,"alternate"===f.direction&&(f.reversed=!f.reversed)):(f.pause(),"Promise"in window&&(Q(),R=b()),f.completed||(f.completed=!0,e("complete"))),
k=0);e("update")}a=void 0===a?{}:a;var m,t,k=0,Q=null,R=b(),f=fa(a);f.reset=function(){var a=f.direction,b=f.loop;f.currentTime=0;f.progress=0;f.paused=!0;f.began=!1;f.completed=!1;f.reversed="reverse"===a;f.remaining="alternate"===a&&1===b?2:b;for(a=f.children.length;a--;)b=f.children[a],b.seek(b.offset),b.reset()};f.tick=function(a){m=a;t||(t=m);h((k+m-t)*n.speed)};f.seek=function(a){h(d(a))};f.pause=function(){var a=q.indexOf(f);-1<a&&q.splice(a,1);f.paused=!0};f.play=function(){f.paused&&(f.paused=
!1,t=0,k=d(f.currentTime),q.push(f),z||ja())};f.reverse=function(){f.reversed=!f.reversed;t=0;k=d(f.currentTime)};f.restart=function(){f.pause();f.reset();f.play()};f.finished=R;f.reset();f.autoplay&&f.play();return f}var ga={update:void 0,begin:void 0,run:void 0,complete:void 0,loop:1,direction:"normal",autoplay:!0,offset:0},ha={duration:1E3,delay:0,easing:"easeOutElastic",elasticity:500,round:0},V="translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY".split(" "),
E,g={arr:function(a){return Array.isArray(a)},obj:function(a){return-1<Object.prototype.toString.call(a).indexOf("Object")},svg:function(a){return a instanceof SVGElement},dom:function(a){return a.nodeType||g.svg(a)},str:function(a){return"string"===typeof a},fnc:function(a){return"function"===typeof a},und:function(a){return"undefined"===typeof a},hex:function(a){return/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a)},rgb:function(a){return/^rgb/.test(a)},hsl:function(a){return/^hsl/.test(a)},col:function(a){return g.hex(a)||
g.rgb(a)||g.hsl(a)}},y=function(){function a(a,d,c){return(((1-3*c+3*d)*a+(3*c-6*d))*a+3*d)*a}return function(b,d,c,e){if(0<=b&&1>=b&&0<=c&&1>=c){var g=new Float32Array(11);if(b!==d||c!==e)for(var h=0;11>h;++h)g[h]=a(.1*h,b,c);return function(h){if(b===d&&c===e)return h;if(0===h)return 0;if(1===h)return 1;for(var m=0,k=1;10!==k&&g[k]<=h;++k)m+=.1;--k;var k=m+(h-g[k])/(g[k+1]-g[k])*.1,l=3*(1-3*c+3*b)*k*k+2*(3*c-6*b)*k+3*b;if(.001<=l){for(m=0;4>m;++m){l=3*(1-3*c+3*b)*k*k+2*(3*c-6*b)*k+3*b;if(0===l)break;
var n=a(k,b,c)-h,k=k-n/l}h=k}else if(0===l)h=k;else{var k=m,m=m+.1,f=0;do n=k+(m-k)/2,l=a(n,b,c)-h,0<l?m=n:k=n;while(1e-7<Math.abs(l)&&10>++f);h=n}return a(h,d,e)}}}}(),N=function(){function a(a,b){return 0===a||1===a?a:-Math.pow(2,10*(a-1))*Math.sin(2*(a-1-b/(2*Math.PI)*Math.asin(1))*Math.PI/b)}var b="Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "),d={In:[[.55,.085,.68,.53],[.55,.055,.675,.19],[.895,.03,.685,.22],[.755,.05,.855,.06],[.47,0,.745,.715],[.95,.05,.795,.035],[.6,.04,.98,
.335],[.6,-.28,.735,.045],a],Out:[[.25,.46,.45,.94],[.215,.61,.355,1],[.165,.84,.44,1],[.23,1,.32,1],[.39,.575,.565,1],[.19,1,.22,1],[.075,.82,.165,1],[.175,.885,.32,1.275],function(b,c){return 1-a(1-b,c)}],InOut:[[.455,.03,.515,.955],[.645,.045,.355,1],[.77,0,.175,1],[.86,0,.07,1],[.445,.05,.55,.95],[1,0,0,1],[.785,.135,.15,.86],[.68,-.55,.265,1.55],function(b,c){return.5>b?a(2*b,c)/2:1-a(-2*b+2,c)/2}]},c={linear:y(.25,.25,.75,.75)},e={},l;for(l in d)e.type=l,d[e.type].forEach(function(a){return function(d,
e){c["ease"+a.type+b[e]]=g.fnc(d)?d:y.apply($jscomp$this,d)}}(e)),e={type:e.type};return c}(),ia={css:function(a,b,d){return a.style[b]=d},attribute:function(a,b,d){return a.setAttribute(b,d)},object:function(a,b,d){return a[b]=d},transform:function(a,b,d,c,e){c[e]||(c[e]=[]);c[e].push(b+"("+d+")")}},q=[],z=0,ja=function(){function a(){z=requestAnimationFrame(b)}function b(b){var c=q.length;if(c){for(var d=0;d<c;)q[d]&&q[d].tick(b),d++;a()}else cancelAnimationFrame(z),z=0}return a}();n.version="2.0.2";
n.speed=1;n.running=q;n.remove=function(a){a=M(a);for(var b=q.length;b--;)for(var d=q[b],c=d.animations,e=c.length;e--;)F(a,c[e].animatable.target)&&(c.splice(e,1),c.length||d.pause())};n.getValue=J;n.path=function(a,b){var d=g.str(a)?v(a)[0]:a,c=b||100;return function(a){return{el:d,property:a,totalLength:d.getTotalLength()*(c/100)}}};n.setDashoffset=function(a){var b=a.getTotalLength();a.setAttribute("stroke-dasharray",b);return b};n.bezier=y;n.easings=N;n.timeline=function(a){var b=n(a);b.pause();
b.duration=0;b.add=function(a){b.children.forEach(function(a){a.began=!0;a.completed=!0});w(a).forEach(function(a){var c=b.duration,d=a.offset;a.autoplay=!1;a.offset=g.und(d)?c:K(d,c);b.seek(a.offset);a=n(a);a.duration>c&&(b.duration=a.duration);a.began=!0;b.children.push(a)});b.reset();b.seek(0);b.autoplay&&b.restart();return b};return b};n.random=function(a,b){return Math.floor(Math.random()*(b-a+1))+a};return n});

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(99);

__webpack_require__(100);

__webpack_require__(115);

__webpack_require__(116);

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _functionsVanilla = __webpack_require__(1);

var functions = _interopRequireWildcard(_functionsVanilla);

var _analyticsHandlers = __webpack_require__(3);

var _analyticsHandlers2 = _interopRequireDefault(_analyticsHandlers);

var _analytics = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/*
 * Throttling function for scrolling events
 */
function throttle(delay, callback) {
  var previousCall = new Date().getTime();
  return function () {
    var time = new Date().getTime();

    if (time - previousCall >= delay) {
      previousCall = time;
      callback.apply(null, arguments);
    }
  };
}

var trackEvent = function trackEvent(event, payload) {
  payload ? analytics.track(event, payload) : analytics.track(event);
};

var getDataHandlerAttr = function getDataHandlerAttr(node) {
  return node.getAttribute('data-analytics-handler');
};

var getEventData = function getEventData(handler, currentPage, node) {
  var eventData = _analyticsHandlers2.default[handler];

  if (!eventData) {
    console.warn('No analytics handler for: ' + handler);
    return false;
  }

  return _analyticsHandlers2.default[handler](currentPage, node);
};

var attachClickEvent = function attachClickEvent(node, eventName, payload) {
  node.addEventListener('click', function (e) {
    trackEvent(eventName, payload);
  });
};

var attachHoverEvent = function attachHoverEvent(node, eventName, payload) {
  node.addEventListener('mouseenter', function (e) {
    e.stopPropagation();
    trackEvent(eventName, payload);
  });
};

var attachHoverNoClickEvent = function attachHoverNoClickEvent(node, eventName, payload) {
  node.addEventListener('mouseenter', function (e) {
    var clicked = false;
    var called = false;

    node.addEventListener('mousedown', function () {
      clicked = true;
    });

    node.addEventListener('mouseout', function (e) {
      if (!clicked && !called) {
        trackEvent(eventName, payload);
        called = true;
      }

      node.removeEventListener('mousedown');
      node.removeEventListener('mouseout');
    });
  });
};

var checkEventOptions = function checkEventOptions(pageName, options) {
  var lang = _analytics.convertLanguage[pageName];
  if (!(options && options.ignoreView)) {
    if (lang) {
      trackEvent('splash.regional.view', { locale: lang });
    } else {
      trackEvent('splash.' + pageName + '.view');
    }
  }
  if (options && options.trackScrolling) {
    addScrollEvent(pageName);
  }
};

var addCampaignTracking = function addCampaignTracking() {
  var campaignUtils = {};

  /*
   * Turn query param string into a hash.
   */
  campaignUtils.deparam = function deparam(str) {
    var pairs, hash;
    // remove the '?'
    if (!str || !str.length) {
      return;
    }

    if (str[0] === '?') {
      str = str.slice(1);
    }
    str = decodeURIComponent(str);

    // this gives back something of the form: [[key1, val1], [key2, val2]]
    pairs = str.split("&").map(function (item) {
      return item.split("=");
    });

    hash = {};
    pairs.forEach(function (pair) {
      hash[pair[0]] = pair[1];
    });

    return hash;
  };

  campaignUtils.extractCampaignAttributionData = function extractCampaignAttributionData(queryParams) {
    var campaignFields, campaignData;
    campaignFields = ["utm_source", "utm_medium", "utm_term", "utm_content", "utm_campaign"];
    campaignData = {};

    queryParams && campaignFields.forEach(function (field) {
      if (queryParams[field]) {
        campaignData[field] = queryParams[field];
      }
    });

    return campaignData;
  };

  var query, campaignData;
  query = campaignUtils.deparam(window.location.search);
  campaignData = campaignUtils.extractCampaignAttributionData(query);
  if (campaignData && campaignData.utm_campaign) {
    analytics.track('campaign', campaignData);
  }
};

var addScrollEvent = function addScrollEvent(pageName) {
  var sections = [].slice.call(document.querySelectorAll('section'));

  window.onscroll = throttle(300, function () {
    sections.forEach(function (thisSection, index, sectionArray) {
      var eventProperties = {};

      if (window.pageYOffset >= thisSection.offsetTop) {
        eventProperties.page_element = thisSection.getAttribute('data-scroll-element');
        trackEvent('splash.' + pageName + '.scroll', eventProperties);
        sections.splice(index, 1);
      }
    });
  });
};

var getAnalyticsHandlers = function getAnalyticsHandlers(node) {
  return getDataHandlerAttr(node).split(',');
};

var attachAnalyticsToDOM = function attachAnalyticsToDOM(currentPage, options) {
  document.querySelectorAll('[data-analytics-handler]').forEach(function (node) {
    var handlers = getAnalyticsHandlers(node);

    handlers.forEach(function (handler) {
      var eventData = getEventData(handler, currentPage, node);

      if (!eventData) {
        return;
      }

      var eventType = eventData.eventType,
          eventName = eventData.eventName,
          payload = eventData.payload;


      if (eventType === 'click') {
        attachClickEvent(node, eventName, payload);
      }

      if (eventType === 'hover') {
        attachHoverEvent(node, eventName, payload);
      }

      if (eventType === 'hover-no-click') {
        attachHoverNoClickEvent(node, eventName, payload);
      }
    });
  });
};

var plangridTrackEvents = function plangridTrackEvents(pageName, options) {
  checkEventOptions(pageName, options);
  addCampaignTracking();
  attachAnalyticsToDOM(pageName);
};

exports.default = plangridTrackEvents;

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _getHeaderFooterClickEventName = __webpack_require__(4);

var _getHeaderFooterClickEventName2 = _interopRequireDefault(_getHeaderFooterClickEventName);

var _analytics = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  "header-logo-click": function headerLogoClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.header.plangrid.click',
      payload: {
        'current_page': (0, _analytics.getCurrentPage)(currentPage)
      }
    };
  },
  "header-link-click": function headerLinkClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: (0, _getHeaderFooterClickEventName2.default)(node, 'header'),
      payload: {
        'current_page': (0, _analytics.getCurrentPage)(currentPage)
      }
    };
  },
  "header-globe-click": function headerGlobeClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.regional.header.click',
      payload: {
        'locale': (0, _analytics.getRegionalHeaderLinkName)(node)
      }
    };
  },
  "regional-header-link-click": function regionalHeaderLinkClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.regional.header.click',
      payload: {
        'link': (0, _analytics.getRegionalHeaderLinkName)(node),
        'locale': (0, _analytics.getCurrentPage)(currentPage)
      }
    };
  },
  "regional-cta-click": function regionalCtaClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.regional.signup.submit',
      payload: {
        'locale': (0, _analytics.getCurrentPage)(currentPage)
      }
    };
  },
  "header-phone-click": function headerPhoneClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.header.phone.click',
      payload: {
        'current_page': currentPage
      }
    };
  },
  "header-login-click": function headerLoginClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.header.login.click',
      payload: {
        'current_page': (0, _analytics.getCurrentPage)(currentPage)
      }
    };
  },
  "header-signup-click": function headerSignupClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.header.signup.click',
      payload: {
        'current_page': (0, _analytics.getCurrentPage)(currentPage)
      }
    };
  },
  "header-mobile-expand-click": function headerMobileExpandClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.header.expand.click',
      payload: {
        'current_page': currentPage
      }
    };
  },
  "footer-link-click": function footerLinkClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: (0, _getHeaderFooterClickEventName2.default)(node, 'footer'),
      payload: {
        'current_page': currentPage
      }
    };
  },
  "footer-ios-download-click": function footerIosDownloadClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.download.click',
      payload: {
        'current_page': currentPage,
        'button_place': 'footer',
        platform: 'ios'
      }
    };
  },
  "footer-android-download-click": function footerAndroidDownloadClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.download.click',
      payload: {
        'current_page': currentPage,
        'button_place': 'footer',
        platform: 'android'
      }
    };
  },
  "footer-windows-download-click": function footerWindowsDownloadClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.download.click',
      payload: {
        'current_page': currentPage,
        'button_place': 'footer',
        platform: 'windows'
      }
    };
  },
  "home-product-explore-click": function homeProductExploreClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.product_explore.click'
    };
  },
  "home-video-click": function homeVideoClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.video.click'
    };
  },
  "home-video-hover-no-click": function homeVideoHoverNoClick(currentPage) {
    return {
      eventType: 'hover-no-click',
      eventName: 'splash.home.video.hover'
    };
  },
  "home-testimonials-click": function homeTestimonialsClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.testimonials.click'
    };
  },
  "home-mainCTA-ios-download-click": function homeMainCTAIosDownloadClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.download.click',
      payload: {
        'button_place': 'main_CTA',
        'platform': 'ios'
      }
    };
  },
  "home-mainCTA-windows-download-click": function homeMainCTAWindowsDownloadClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.download.click',
      payload: {
        'button_place': 'main_CTA',
        'platform': 'windows'
      }
    };
  },
  "home-mainCTA-android-download-click": function homeMainCTAAndroidDownloadClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.download.click',
      payload: {
        'button_place': 'main_CTA',
        'platform': 'android'
      }
    };
  },
  "home-secondaryCTA-signup-click": function homeSecondaryCTASignupClick() {
    return {
      eventType: 'click',
      eventName: 'splash.signup.submit',
      payload: {
        'button_place': 'secondary_CTA'
      }
    };
  },
  "home-mainCTA-signup-click": function homeMainCTASignupClick() {
    return {
      eventType: 'click',
      eventName: 'splash.signup.submit',
      payload: {
        'button_place': 'main_CTA'
      }
    };
  },
  "home-projects-category-click": function homeProjectsCategoryClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.home.projects_category.click',
      payload: {
        'context': (0, _analytics.transformNodeText)(node.text)
      }
    };
  },
  "home-projects-category-hover": function homeProjectsCategoryHover(currentPage, node) {
    return {
      eventType: 'hover',
      eventName: 'splash.home.projects_category.hover',
      payload: {
        'context': (0, _analytics.transformNodeText)(node.text)
      }
    };
  },
  "home-projects-explore-click": function homeProjectsExploreClick() {
    return {
      eventType: 'click',
      eventName: 'splash.home.projects_explore.click'
    };
  },
  "product-mainCTA-signup-click": function productMainCTASignupClick() {
    return {
      eventType: 'click',
      eventName: 'splash.product.signup.click',
      payload: {
        'button_place': 'main_cta'
      }
    };
  },
  "product-secondaryCTA-signup-click": function productSecondaryCTASignupClick() {
    return {
      eventType: 'click',
      eventName: 'splash.product.signup.click',
      payload: {
        'button_place': 'secondary_cta'
      }
    };
  },
  "product-bottomCTA-signup-click": function productBottomCTASignupClick() {
    return {
      eventType: 'click',
      eventName: 'splash.product.signup.click',
      payload: {
        'button_place': 'bottom_cta'
      }
    };
  },
  "product-ipad-arrow-click": function productIpadArrowClick() {
    return {
      eventType: 'click',
      eventName: 'splash.product.ipad_features.click'
    };
  },
  "product-feature-text-click": function productFeatureTextClick() {
    return {
      eventType: 'click',
      eventName: 'splash.product.text_features.click'
    };
  },
  "product-download-click": function productDownloadClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: (0, _analytics.downloadEventName)(currentPage),
      payload: (0, _analytics.getDownloadPayload)(node, currentPage)
    };
  },
  "feature-page-demo-click": function featurePageDemoClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.' + currentPage + '.demo.click'
    };
  },
  "feature-page-video-click": function featurePageVideoClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.' + currentPage + '.video.click'
    };
  },
  "feature-link-click": function featureLinkClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.' + currentPage + '.feature.click',
      payload: {
        'page-click': (0, _analytics.transformNodeText)(node.text)
      }
    };
  },
  "header-contact-click": function headerContactClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.' + currentPage + '.contact_sales.click'
    };
  },
  "sidenav-filter-click": function sidenavFilterClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.' + currentPage + '.filter.click',
      payload: {
        type: (0, _analytics.transformNodeText)(node.getAttribute('data-link-category'))
      }
    };
  },
  "sidenav-mobile-click": function sidenavMobileClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.' + currentPage + '.dropdown.click'
    };
  },
  "partner-sidenav-become-a-partner-click": function partnerSidenavBecomeAPartnerClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.resources.partners.contact.click',
      payload: {
        context: 'sidenav'
      }
    };
  },
  "partner-sidenav-explore-our-api-click": function partnerSidenavExploreOurApiClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.resources.partners.doc.click',
      payload: {
        context: 'sidenav'
      }
    };
  },
  "projects-project-click": function projectsProjectClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.projects.project.click',
      payload: {
        company_name: (0, _analytics.getCompanyFromNode)(node),
        project_name: (0, _analytics.getHref)(node)
      }
    };
  },
  "case-study-quote-click": function caseStudyQuoteClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.projects.quote.click',
      payload: {
        project_name: currentPage
      }
    };
  },
  "case-study-download-click": function caseStudyDownloadClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.projects.download.click',
      payload: {
        project_name: currentPage
      }
    };
  },
  "case-study-signup-click": function caseStudySignupClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.projects.signup.click',
      payload: {
        project_name: currentPage
      }
    };
  },
  "video-feature-click": function videoFeatureClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: (0, _analytics.featureExploreEventName)(currentPage),
      payload: (0, _analytics.getVideoPayload)(node, currentPage)
    };
  },
  "events-filter-click": function eventsFilterClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.events.filter.click',
      payload: {
        'filter': (0, _analytics.transformNodeText)(node.getAttribute('value'))
      }
    };
  },
  "userGroups-lead-click": function userGroupsLeadClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.user_groups.lead.click'
    };
  },
  "userGroups-join-click": function userGroupsJoinClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.user_groups.join.click'
    };
  },
  "userGroups-faq-click": function userGroupsFaqClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.user_groups.faq.click'
    };
  }
};

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _animejs = __webpack_require__(16);

var _animejs2 = _interopRequireDefault(_animejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var resizeTimeout = void 0,
      videoRestartTimeout = void 0,
      position = 0;
  var features = document.querySelectorAll('.feature');
  var buttons = document.querySelectorAll('.features button');
  var form = document.querySelector('.contact form');
  var leftArrow = document.querySelector('.features-section .arrow.left');
  var rightArrow = document.querySelector('.features-section .arrow.right');

  features.forEach(function (feature, index) {
    var video = feature.querySelector('video');

    feature.querySelector('.feature-summary').addEventListener('click', function (e) {
      playVideo(index);
    }, false);
  });

  buttons.forEach(function (button, i) {
    button.addEventListener('click', function (e) {
      animateTo(i);
    }, false);
  });

  leftArrow.addEventListener('click', function (e) {
    var nextPosition = position === 0 ? features.length - 1 : position - 1;
    animateTo(nextPosition, false);
  }, false);

  rightArrow.addEventListener('click', function (e) {
    var nextPosition = position === features.length - 1 ? 0 : position + 1;
    animateTo(nextPosition, true);
  }, false);

  window.addEventListener("resize", resizeThrottler, false);

  startVideos();

  function startVideos() {
    position = 0;
    features.forEach(function (feature, i) {
      features[i].removeAttribute('style');
    });
    buttons.forEach(function (button) {
      button.classList.remove('active');
    });
    if (window.innerWidth < 1099) {
      features[0].setAttribute('style', 'transform: translateX(0)');
    } else {
      features[0].classList.add('active');
    }
    buttons[0].classList.add('active');
    features[0].classList.add('active');
    features[0].querySelector('video').play();
  }

  function playVideo(index) {
    if (window.innerWidth > 1099) {
      focusTo(index);
    } else {
      animateTo(index);
    }
  }

  function focusTo(index) {
    var feature = features[index];
    var video = feature.querySelector('video');
    features.forEach(function (feature) {
      feature.classList.remove('active');
      feature.querySelector('video').pause();
    });
    video.currentTime = 0;
    feature.classList.add('active');
    video.play();
    position = index;
  }

  function animateTo(index, direction) {
    if (index === position) return false;
    var forwards = typeof direction !== 'undefined' ? direction : index > position;
    features.forEach(function (feature, i) {
      features[i].querySelector('video').pause();
    });
    buttons.forEach(function (button) {
      button.classList.remove('active');
    });
    (0, _animejs2.default)({
      targets: features[index],
      translateX: forwards ? ['100%', '0%'] : ['-100%', '0%'],
      duration: 300,
      easing: 'easeInOutQuad',
      begin: function begin() {
        buttons[index].classList.add('active');
      },
      complete: function complete() {
        features[index].querySelector('video').play();
      }
    });
    (0, _animejs2.default)({
      targets: features[position],
      translateX: forwards ? ['0%', '-100%'] : ['0%', '100%'],
      duration: 300,
      easing: 'easeInOutQuad'
    });
    position = index;
  }

  function resizeThrottler() {
    // Ignore resize events as long as an actualResizeHandler execution is in the queue
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(function () {
        resizeTimeout = null;
        startVideos();
      }, 66); // Rate of 15fps
    }
  }
};

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    transformNodeText = _require.transformNodeText;

module.exports = function (node, option) {
  if (!(option === 'header' || option === 'footer')) {
    throw "Invalid option";
  }
  return 'splash.' + option + '.' + transformNodeText(node.text) + '.click';
};

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (href) {
  var splitHref = href.split('/');

  return splitHref[splitHref.length - 2].replace(/\-/g, '_');
};

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _animejs = __webpack_require__(16);

var _animejs2 = _interopRequireDefault(_animejs);

var _amplitudeInitVanilla = __webpack_require__(2);

var _amplitudeInitVanilla2 = _interopRequireDefault(_amplitudeInitVanilla);

var _getPageNameFromLocation = __webpack_require__(6);

var _getPageNameFromLocation2 = _interopRequireDefault(_getPageNameFromLocation);

var _phoneDemo = __webpack_require__(36);

var _phoneDemo2 = _interopRequireDefault(_phoneDemo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = exports.init = function init() {
  var pageName = (0, _getPageNameFromLocation2.default)(window.location.href);
  (0, _amplitudeInitVanilla2.default)(pageName);
  (0, _phoneDemo2.default)();
};

document.addEventListener('DOMContentLoaded', init);

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// /assets/js/regional.df96e3f08d5d2b1fc9cf.js